export default [
  {
    icon: 'GridIcon',
    route: 'historie',
    title: 'Historie'
  },
]
